<template>
  <div class="pay-result-page">
    <div class="result-content">
      <div class="result-icon fail">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.6.4-3.2 1.2-4.6l130.1-155L340.7 295a8.07 8.07 0 0 1 6-13.2l66.1.3L512 420.7l105.3-126.5 66-.3c4.4 0 8 3.5 8 8 0 1.6-.4 3.2-1.2 4.6L553.5 514l130.1 155c.9 1.4 1.2 3 1.2 4.6 0 4.4-3.6 8-8 8z" fill="#ff4757"/>
        </svg>
      </div>
      <h2 class="result-title">支付失败</h2>
      <p class="result-desc">{{ errorMsg || '支付过程中出现异常，请稍后重试' }}</p>
      
      <div class="order-info" v-if="orderInfo">
        <div class="info-item">
          <span class="info-label">订单号：</span>
          <span class="info-value">{{ orderInfo.mchOrderNo || '-' }}</span>
        </div>
        <div class="info-item" v-if="orderInfo.amount">
          <span class="info-label">支付金额：</span>
          <span class="info-value amount">￥{{ (orderInfo.amount / 100).toFixed(2) }}</span>
        </div>
      </div>

      <div class="result-actions">
        <button class="btn-primary" @click="handleRetry">重新支付</button>
        <button class="btn-secondary" @click="handleReturn">返回商户</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PayFail',
  data () {
    return {
      orderInfo: null,
      errorMsg: ''
    }
  },
  mounted () {
    // 从路由参数或查询参数获取订单信息和错误信息
    const params = this.$route.params
    const query = this.$route.query
    
    this.orderInfo = {
      mchOrderNo: params.mchOrderNo || query.mchOrderNo || '',
      amount: params.amount || query.amount || null
    }
    
    this.errorMsg = params.errMsg || query.errMsg || params.errInfo || query.errInfo || ''
  },
  methods: {
    handleRetry () {
      // 返回快捷支付页面重新支付
      const token = this.$route.query.token || this.$route.params.token
      if (token) {
        this.$router.push({ 
          name: 'CashierQuickpay', 
          params: { jToken: token } 
        })
      } else {
        this.$router.go(-1)
      }
    },
    handleReturn () {
      const returnUrl = this.$route.query.returnUrl
      if (returnUrl) {
        location.href = returnUrl
      } else {
        this.handleRetry()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.pay-result-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.result-content {
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.result-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.result-icon.fail {
  background: #fef2f2;
}

.result-icon svg {
  width: 60px;
  height: 60px;
}

.result-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px;
}

.result-desc {
  font-size: 16px;
  color: #666;
  margin: 0 0 32px;
  line-height: 1.5;
  min-height: 24px;
}

.order-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin: 0 0 32px;
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e9ecef;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.info-value.amount {
  font-size: 18px;
  color: #ff4757;
  font-weight: bold;
}

.result-actions {
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-secondary {
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: #fff;
}

.btn-primary:active {
  opacity: 0.9;
  transform: scale(0.98);
}

.btn-secondary {
  background: #f5f5f5;
  color: #666;
}

.btn-secondary:active {
  background: #e9e9e9;
}
</style>

